<template>
    <div ref="appointment">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">科&emsp;&emsp;目</span>
                        <el-select size="mini" v-model="searchParam.subjectId" clearable placeholder="科目" @change="getData">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                        <span class="label">考试日期</span>
                        <el-date-picker
                            v-model="planDateRange"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format='yyyy-MM-dd'
                            :picker-options="pickerOptions2"
                            @change="getData"
                        >
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addVisible = true">添加</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen">
                <el-table-column prop="subjectName" label="科目"  width="120" fixed="left"></el-table-column>
                <el-table-column prop="planDate" label="考试日期"  width="120" fixed="left"></el-table-column>
                <el-table-column prop="openTime" label="开放时间" :formatter="timeFormat" width="150"></el-table-column>
                <el-table-column prop="closeTime" label="关闭时间" :formatter="timeFormat"  width="150"></el-table-column>
                <el-table-column prop="startTime" label="开始进入时间" :formatter="timeFormat"  width="150"></el-table-column>
                <el-table-column prop="endTime" label="截止进入时间" :formatter="timeFormat"  width="150"></el-table-column>
                <el-table-column prop="quota" label="名额" ></el-table-column>
                <el-table-column prop="userCount" label="已报名" ></el-table-column>
                <el-table-column prop="actualCount" label="考试人数" ></el-table-column>
                <el-table-column prop="id" label="操作" width="240"  align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="selectUser(scope.row.id)">名单</el-button>
                        <el-button size="mini" type="danger" :disabled="scope.row.userCount !==0" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
            <!-- 单个添加框 -->
            <el-dialog title="添加" :visible.sync="addVisible" width="70%"  @closed="clearAdd('addForm')">
                <el-form ref="addForm" :model="addForm" label-width="150px">
                    <el-form-item label="考试科目" prop="subjectId">
                        <el-select size="mini" v-model="addForm.subjectId" clearable placeholder="科目">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试日期" prop="planDate" >
                        <el-date-picker v-model="addForm.planDate" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="开放时间">
                        <el-time-picker
                            is-range
                            v-model="addForm.timeRange1"
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开放"
                            end-placeholder="关闭"
                            @change="(timeRange) => timeChange(addForm,timeRange)"
                        >
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="进入时间">
                        <el-time-picker
                            is-range
                            v-model="addForm.timeRange2"
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始进入"
                            end-placeholder="截止进入"
                            @change="(timeRange) => timeChange(addForm,timeRange)"
                        >
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="人数限制" prop="quota" >
                        <el-input-number v-model="addForm.quota" ></el-input-number>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveAdd">保 存</el-button>
                </span>
            </el-dialog>

            <!-- 单个添加框 -->
            <el-dialog title="编辑" :visible.sync="editVisible" width="70%"  @closed="clearAdd('editForm')">
                <el-form ref="editForm" :model="editForm" label-width="150px">
                    <el-form-item label="考试科目" prop="subjectId">
                        <el-select size="mini" v-model="editForm.subjectId" :disabled="editForm.userCount !== 0" clearable placeholder="科目">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试日期" prop="planDate"  >
                        <el-date-picker v-model="editForm.planDate" value-format="yyyy-MM-dd" :disabled="editForm.userCount !== 0" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="开放时间">
                        <el-time-picker
                            is-range
                            v-model="editForm.timeRange1"
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="最早开始"
                            end-placeholder="最晚开始"
                            :disabled="editForm.userCount !== 0"
                            @change="(timeRange) => timeChange(editForm,timeRange)"
                        >
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="进入时间">
                        <el-time-picker
                            is-range
                            v-model="editForm.timeRange2"
                            value-format="HH:mm:ss"
                            range-separator="至"
                            start-placeholder="最早开始"
                            end-placeholder="最晚开始"
                            :disabled="editForm.userCount !== 0"
                            @change="(timeRange) => timeChange(editForm,timeRange)"
                        >
                        </el-time-picker>
                    </el-form-item>
                    <el-form-item label="人数限制" prop="quota" >
                        <el-input-number v-model="editForm.quota" :min="editForm.userCount"></el-input-number>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="editVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveEdit">保 存</el-button>
                </span>
            </el-dialog>
            <el-dialog title="预约名单" :visible.sync="userListVisible" width="70%">
                <el-table :data="userList">
                    <el-table-column prop="chName" label="姓名" width="120" fixed></el-table-column>
                    <el-table-column prop="enName" label="姓名拼音" width="120"></el-table-column>
                    <el-table-column prop="email" label="邮箱" width="150"></el-table-column>
                    <el-table-column prop="tel" label="手机号码" width="120"></el-table-column>
                    <el-table-column prop="company" label="单位"></el-table-column>
                    <el-table-column prop="title" label="职务"></el-table-column>
                    <el-table-column prop="institutions" label="培训机构"></el-table-column>
<!--                    <el-table-column >-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-tag v-if="scope.row.chName" type="primary" disable-transitions>已交卷</el-tag>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import dateFormat from 'format-datetime';

    export default {
        name:'appointment',
        data() {
            return {
                tableData1: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }],
                search: ''
            ,
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:20,
                },
                planDateRange:[
                    // dateFormat(new Date(),'yyyy-MM-dd'),
                    // dateFormat(new Date(new Date().getTime()+3600 * 1000 * 24 * 30),'yyyy-MM-dd')
                ],
                pickerOptions2: {
                    // disabledDate(date) {
                    //     return date < Date.now()- 3600 * 1000 * 24;
                    // },
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                tableData:[],
                subjectList: [],
                totalNumber:0,
                addVisible:false,
                editVisible:false,
                userListVisible: false,
                addForm:{
                    planDate: dateFormat(new Date(new Date().getTime()+3600 * 1000 * 24 * 7),'yyyy-MM-dd'),
                    timeRange1:["11:00:00","14:00:00"],
                    timeRange2:["11:00:00","12:00:00"],
                    quota: 50,
                },
                editForm: {},
                userList:[],
                userListParam: 'all'
            };
        },
        created(){
            this.getSubjectList();
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getData(){
                let res = await this.$axios.post('/manage/appointment/selectByPage',{
                    pageNum:this.searchParam.pageNum,
                    pageSize:this.searchParam.pageSize,
                    subjectId:this.searchParam.subjectId,
                    planDateStart:this.planDateRange[0],
                    planDateEnd:this.planDateRange[1],
                    orderById: false
                });
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            },
            edit(plan) {
                this.editForm = {
                    id:plan.id,
                    subjectId: plan.subjectId,
                    planDate: plan.planDate,
                    timeRange1:[plan.openTime.substring(11),plan.closeTime.substring(11)],
                    timeRange2:[plan.startTime.substring(11),plan.endTime.substring(11)],
                    quota: plan.quota,
                    userCount: plan.userCount
                }
                this.editVisible = true;
            },
            async saveAdd() {
                let data = {
                    subjectId: this.addForm.subjectId,
                    planDate: this.addForm.planDate,
                    openTime: this.addForm.planDate + " "+ this.addForm.timeRange1[0],
                    closeTime: this.addForm.planDate + " "+ this.addForm.timeRange1[1],
                    startTime: this.addForm.planDate + " "+ this.addForm.timeRange2[0],
                    endTime: this.addForm.planDate + " " + this.addForm.timeRange2[1],
                    quota: this.addForm.quota
                };
                let res = await this.$axios.post("/manage/appointment/insert",data);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                } else  {
                    this.addVisible=false;
                    await this.getData();
                }
            },
            async saveEdit() {
                console.log(this.editForm);
                let data = {
                    id: this.editForm.id,
                    subjectId: this.editForm.subjectId,
                    planDate: this.editForm.planDate,
                    openTime: this.editForm.planDate + " "+ this.editForm.timeRange1[0],
                    closeTime: this.editForm.planDate + " " + this.editForm.timeRange1[1],
                    startTime: this.editForm.planDate + " "+ this.editForm.timeRange2[0],
                    endTime: this.editForm.planDate + " " + this.editForm.timeRange2[1],
                    quota: this.editForm.quota
                };
                let res = await this.$axios.post("/manage/appointment/updateQuota",data);
                if (res.code !== 200) {
                    this.$message.error(res.errMsg);
                } else {
                    await this.getData();
                    this.editVisible=false;
                }
            },
            async remove(planId) {
                let res = await this.$axios.get(`/manage/appointment/delete/${planId}`);
                if (res.code === 200) {
                    await this.getData();
                }
            },
            clearAdd() {
                this.addForm= {
                    planDate: dateFormat(new Date(new Date().getTime()+3600 * 1000 * 24 * 7),'yyyy-MM-dd'),
                    timeRange1:["11:00:00","14:00:00"],
                    timeRange2:["11:00:00","12:00:00"],
                    quota: 50,
                }
            },
            async getSubjectList() {
                let res = await this.$axios.get("/manage/subject/selectAll");
                if (res.code === 200) {
                    this.subjectList = res.data.filter(e=>e.appointmentType === 'appointment');
                }
            },
            async selectUser(planId) {
                let res = await this.$axios.get(`/manage/appointment/userList/${planId}`);
                if (res.code === 200) {
                    this.userList = res.data;
                    this.userListVisible = true;
                }
            },
            timeChange(editForm, timeRange) {
                this.$set(editForm.timeRange1,0,timeRange[0]);
                this.$set(editForm.timeRange2,0,timeRange[0]);
                if (editForm.timeRange1[0] >= editForm.timeRange1[1]) {
                    this.$set(editForm.timeRange1,1,dateFormat(new Date(new Date(editForm.planDate + " "+editForm.timeRange1[0]).getTime()+3600 * 1000*3),'HH:mm:ss'));
                }
                if (editForm.timeRange2[0] >= editForm.timeRange2[1]) {
                    this.$set(editForm.timeRange2,1,dateFormat(new Date(new Date(editForm.planDate + " "+editForm.timeRange2[0]).getTime()+3600 * 1000),'HH:mm:ss'));
                }
            },
            timeFormat(row, column, dateTime, index) {
                if (dateTime) {
                    return dateTime.substring(11);
                } else {
                    return dateTime;
                }
            }
        }
    };
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-col{
    margin: 10px 0;
}
/* .handle-select {
    width: 200px;
}

.handle-input {
    width: 200px;
} */
.label {
    margin-right: 10px;
    color: #606266;
}
.question {
    /*border-bottom-width: 1px;*/
    border-bottom: 1px solid #dcdfe6;
    border-top: 1px solid #dcdfe6;
    margin-top: -1px;
    width: auto;
}
</style>
